<template>
	<div class="contain">
		<div class="home" id="home">
			<div class="header" :class="{headerActive:!top}">
				<div class="content flex-sb aic">
					<div class="header-left flex aic">
						<!-- <img src="./assets/logo.png" class="logo" alt=""> -->
						<span :class="{filter:!top}">众包悬赏（众包赚客）</span>
					</div>
					<div class="menu flex-sb">
						<p @click="jump('home')" :class="{filter:!top,opa1:page1}">首页<span class="tabblock"
								:class="{opa1:page1}"></span></p>
						<p @click="jump('ser')" :class="{filter:!top,opa1:page2}">产品服务<span class="tabblock"
								:class="{opa1:page2}"></span></p>
						<p @click="jump('about')" :class="{filter:!top,opa1:page3}">关于我们<span class="tabblock"
								:class="{opa1:page3}"></span></p>
						<p @click="jump('contact')" :class="{filter:!top,opa1:page4}">联系我们<span class="tabblock"
								:class="{opa1:page4}"></span></p>
						<p @click="download" class="download1">
							<span :class="{filter:!top}">立即下载APP</span>
							<img src="./assets/img/erweima2.png" alt="">
						</p>
					</div>
				</div>
			</div>
			<div class="content home-main">
				<div class="content-left">
					<p data-aos='fade-right' data-aos-duration="400">众包悬赏（众包赚客）</p>
					<dd data-aos='fade-right' data-aos-duration="600">简单·专业·创新·共赢</dd>
					<span data-aos='fade-right'
						data-aos-duration="800">众包悬赏（众包赚客）基于云计算和大数据技术，构建了灵活用工行业的全流程数字化解决方案，打造高效便捷、合作共赢的网络体系。</span>
					<div class="button download2" data-aos='fade-right' data-aos-duration="1000" @click="download">
						立即下载APP
						<img src="./assets/img/erweima2.png" alt="">
					</div>
				</div>
				<div class="content-right" data-aos='fade-left' data-aos-duration="600">
					<img src="./assets/img/homeimg.png" alt="">
				</div>
			</div>
		</div>

		<div class="problem content" id="ser">
			<div class="title">
				<p data-aos="flip-up" data-aos-duration="600">您是否也遇到这些问题</p>
			</div>
			<div class="problem-list">
				<div class="problem-item" data-aos="flip-left" data-aos-duration="200">
					<img src="./assets/img/zhaoren.png" alt="">
					<p>招人才难</p>
					<dd>就业人员灵活，合适人员难找</dd>
				</div>
				<div class="problem-item" data-aos="flip-left" data-aos-duration="600">
					<img src="./assets/img/guanli.png" alt="">
					<p>找副业难</p>
					<dd>兼职渠道过多，选得眼花缭乱</dd>
				</div>
				<div class="problem-item" data-aos="flip-left" data-aos-duration="1000">
					<img src="./assets/img/xiaolv.png" alt="">
					<p>效率低下</p>
					<dd>耗费大量时间、精力，结果差强人意</dd>
				</div>
			</div>
		</div>
		
		<div class="swipermain content">
			<div class="title">
				<p data-aos="flip-up" data-aos-duration="600">专业兼职平台，解决您的赚钱难题！</p>
			</div>
			<div class="swipermain-main flex-sb aic">
				<!-- Swiper -->
				<div class="swiper-left">
					<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide">
								<img src="./assets/img/banner1.png" />
							</div>
							<div class="swiper-slide">
								<img src="./assets/img/banner2.png" />
							</div>
						</div>
						<!-- Add Pagination -->
						<div class="swiper-pagination"></div>
					</div>
					<div class="yellow-block">
		
					</div>
				</div>
		
				<div class="swipermain-word">
					<p>众包悬赏（众包赚客）是一款专为兼职人群打造的副业兼职赚钱工具，依托于众多企业商家的众包兼职需求。</p>
					<p>海量兼职收入丰厚，涵盖兼职招工、临时工招募、调查问卷、数据审核、广告采集、技能交易等多个方面的兼职需求，实现了即时投递及时沟通，真正解决您的兼职难题！</p>
					<p>所有职位经多重认证审核，全方位保障兼职安全！</p>
				</div>
			</div>
		
		</div>

		<div class="solve content">
			<div class="title">
				<p data-aos="zoom-in" data-aos-duration="600">专业众包招募，解决您的用工难题！</p>
			</div>
			<div class="solve-item">
				<div class="solve-item-left" data-aos='fade-right' data-aos-duration="600">
					<img src="./assets/img/chengben.png" alt="">
				</div>
				<div class="solve-item-right" data-aos='fade-left' data-aos-duration="600">
					<span></span>
					<p>成本控制：</p>
					<dd>对于企业而言，成本控制是使用灵活用工最重要原因之一，也是其基本性诉求，灵活用工模式可以有效降低企业的隐性成本</dd>
				</div>
			</div>
			<div class="solve-item">
				<div class="solve-item-right" data-aos='fade-right' data-aos-duration="600">
					<span></span>
					<p>用工效率：</p>
					<dd>灵活用工模式有效解决了企业用工难
						招工难的问题，同时提高了企业的招
						聘效率、上岗效率、组织效率、管理
						结算效率。</dd>
				</div>
				<div class="solve-item-left" data-aos='fade-left' data-aos-duration="600">
					<img src="./assets/img/xiaolv2.png" alt="">
				</div>
			</div>
			<div class="solve-item">
				<div class="solve-item-left" data-aos='fade-right' data-aos-duration="600">
					<img src="./assets/img/zhiliang.png" alt="">
				</div>
				<div class="solve-item-right" data-aos='fade-left' data-aos-duration="600">
					<span></span>
					<p>用工质量：</p>
					<dd>在强竞争的市场局面下，任何行业的
						任何工作岗位，企业都更倾向于使用
						有经验的熟手，以带来更大的投入产
						出，提高单位时间的产量。因此灵活
						用工模式的用工质量更令企业满意。</dd>
				</div>
			</div>
		</div>

		<div class="about" id="about">
			<div class="content" data-aos="fade-up" data-aos-duration="600">
				<div class="about-title">
					<p>关于我们</p>
				</div>
				<div class="about-main">
					<p>众包悬赏（众包赚客）成立于2019年10月，是一家场景化灵活用工服务平台。</p>
					<p>众包悬赏（众包赚客）致力于灵活用工领域，致于服务灵活用工从业者。目前为全国共享经济业态企业提供新 经济灵活用工招募、为企业智能匹配从业者等灵活用工服务。基于对不同垂直细分行业的深耕，
						已经为互联网、电商、货运、生活服务等垂直行业提供场景化解决方案。经过三年的发展，众包悬赏（众包赚客）构建了覆盖全国范围的服务网络，服务覆盖40余个细分行业数万个企业客户，数百万自由职业者。</p>
					<p>众包悬赏（众包赚客）作为承载新个体经济健康发展的新经济平台，将继续创新，以互联网技术为依托促进更 多自由职业者多渠道就业创业，为稳就业保民生贡献力量。在做好灵活用工平台的同时，将积极
						探索新业态新模式下的发展道路，发展共享经济，为我国的新经济发展做出贡献。</p>
				</div>
			</div>
		</div>

		<div class="contact" id="contact">
			<div class="content">
				<div class="contact-main">
					<div class="contact-left">
						<p>联系我们</p>
						<dd>邮箱：xuniu@xuniuwang.com</dd>
						<dd>地址：四川省成都市锦江区一环路东五段108号1-1幢17层1709号</dd>
					</div>
					<div class="contact-right">
						<img src="./assets/img/erweima2.png" alt="">
						<p>扫二维码了解更多</p>
					</div>
				</div>
				<div class="bottom">
					<p>Copyright©️2019 成都迅牛网络科技有限公司 | <span @click="icp">蜀ICP备19016799号-2</span></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common.css"
	import 'aos/dist/aos.css'
	import AOS from 'aos/dist/aos.js'
	import Swiper from 'swiper/dist/js/swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		data() {
			return {
				top: true,
				page1: true,
				page2: false,
				page3: false,
				page4: false,
			}
		},
		mounted() {
			this.myswiper()
			window.addEventListener('scroll', this.handleScroll) // 监听页面滚动

			AOS.init({
				easing: 'ease-in-out',
				delay: 200,
			})
		},
		methods: {
			myswiper() {
				var swiper = new Swiper('.swiper-container', {
					loop: true,
					speed: 600,
					autoplay: 3000,
					pagination: {
						el: '.swiper-pagination',
					},
				});
			},
			// 获取页面滚动距离
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				console.log(scrollTop)
				if (scrollTop > 50) {
					this.top = false
				} else {
					this.top = true
				}
				if (scrollTop < 1000 * 0.9) {
					this.page1 = true
				} else {
					this.page1 = false
				}
				if (scrollTop < 4875 * 0.9 && scrollTop > 1000 * 0.9) {
					this.page2 = true
				} else {
					this.page2 = false
				}
				if (scrollTop > 4875 * 0.9 && scrollTop < 5675 * 0.9) {
					this.page3 = true
				} else {
					this.page3 = false
				}
				if (scrollTop > 5675 * 0.9) {
					this.page4 = true
				} else {
					this.page4 = false
				}
			},
			jump(val) {
				let id = "#" + val;
				document.querySelector(id).scrollIntoView({
					behavior: "smooth",
					block: "start"
				});
			},
			icp() {
				window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
			},
			download() {
				window.location.href = 'http://global.xuniuwang.com/zbzk/pkg/zbzk.apk'
			}
		},
	}
</script>

<style>
	.home {
		background: linear-gradient(270deg, #289BF9 0%, #4F68EA 100%);
		height: 1080px;
		width: 100%;
		box-sizing: border-box;
	}

	.logo {
		width: 58px;
		height: 58px;
		margin-right: 20px;
	}

	.header-left {
		font-size: 32px;
		color: #fff;
	}

	.header {
		display: flex;
		align-items: center;
		height: 100px;
		width: 100%;
		box-sizing: border-box;
		z-index: 999;
		position: fixed;
		top: 0;
	}

	.headerActive {
		background: #fff;
		box-shadow: 5px 5px 5px rgba(145, 145, 145, 0.1);
		transition: all .3s;
	}

	.filter {
		filter: brightness(0);
		transition: all .3s;
	}

	.menu {
		width: 50%;
		color: #fff;
		font-size: 24px;
		font-weight: 500;
		position: relative;
	}

	.menu p {
		display: flex;
		flex-direction: column;
		align-items: center;
		opacity: 0.65;
		transition: all .3s;
	}

	.menu p span {
		transition: all .3s;
	}

	.tabblock {
		display: block;
		width: 54px;
		height: 4px;
		background: #FFFFFF;
		border-radius: 6px 6px 6px 6px;
		margin-top: 2px;
		opacity: 0;
		transition: all .3s;
	}

	.opa1 {
		opacity: 1 !important;
		transition: all .3s !important;
	}

	.menu p:hover {
		cursor: pointer;
	}

	.home-main {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.content-left {
		padding-top: 100px;
		width: 50%;
	}

	.content-left p {
		font-size: 68px;
		color: #fff;
		margin-bottom: 18px;
	}

	.content-left dd {
		font-size: 56px;
		color: #fff;
		margin-bottom: 26px;
	}

	.content-left span {
		font-size: 28px;
		line-height: 33px;
		color: #fff;
		margin-bottom: 72px;
		display: block;
	}

	.content-left .button {
		width: 288px;
		height: 106px;
		border-radius: 12px 12px 12px 12px;
		background: #FFE81C;
		font-size: 36px;
		color: #1B71E5;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.content-right {
		padding-top: 100px;
		width: 45%;
	}

	.content-right img {
		width: 100%;
		height: auto;
	}

	.problem-list {
		display: flex;
		justify-content: space-between;
	}

	.problem-item {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 442px;
		background: #fff;
		width: calc((100% - 36px) / 3);
		box-shadow: 0px 0px 36px 0px rgba(81, 140, 255, 0.16);
	}

	.problem-item img {
		width: 138px;
		height: 138px;
		margin-bottom: 47px;
	}

	.problem-item p {
		font-size: 32px;
		font-weight: 500;
		margin-bottom: 20px;
	}

	.problem-item dd {
		font-size: 20px;
		font-weight: 400;
	}

	.title {
		color: #2C3E50;
		font-size: 52px;
		font-weight: bold;
		display: flex;
		justify-content: center;
		padding-top: 176px;
		margin-bottom: 88px;
	}

	.solve-item {
		display: flex;
		justify-content: space-between;
		padding: 0 57px;
		margin-bottom: 135px;
	}

	.solve-item:nth-child(2) .solve-item-right span {
		background: #FFEC43;
	}

	.solve-item:nth-last-child(1) {
		margin-bottom: 0;
	}

	.solve-item-left {
		width: 42%;
	}

	.solve-item-left img {
		width: 100%;
		height: auto;
	}

	.solve-item-right {
		padding-top: 114px;
		width: 42%;
	}

	.solve-item-right span {
		display: block;
		width: 138px;
		height: 4px;
		background: #456DFF;
		margin-bottom: 16px;
	}

	.solve-item-right p {
		font-size: 40px;
		font-weight: bold;
		color: #293752;
		margin-bottom: 16px;
	}

	.solve-item-right dd {
		font-size: 32px;
		font-weight: 500;
		color: #42506A;
		line-height: 46px;
	}

	.solve {
		padding-bottom: 164px;
	}

	.about {
		width: 100%;
		background: url('assets/img/bg.png') no-repeat;
		background-size: 120%;
		padding-top: 166px;
		padding-bottom: 183px;
	}

	.about-title {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 64px;
		font-weight: bold;
		color: #FFFFFF;
		margin-bottom: 38px;
	}

	.about-main {
		font-size: 32px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 38px;
	}

	.about-main p {
		margin-bottom: 48px;
	}

	.about-main p:nth-last-child(1) {
		margin-bottom: 0;
	}

	.contact {
		background: #2E4CB9;
		width: 100%;
	}

	.contact-main {
		display: flex;
		justify-content: space-between;
		padding: 28px 0;
		border-bottom: 1px solid rgba(255, 255, 255, 0.51);
	}

	.contact-left p {
		font-size: 36px;
		font-weight: 500;
		color: #FFFFFF;
		margin-bottom: 28px;
	}

	.contact-left dd {
		font-size: 24px;
		font-weight: 400;
		color: #FFFFFF;
		margin-bottom: 28px;
	}

	.contact-right {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.contact-right img {
		width: 164px;
		height: 164px;
		margin-bottom: 8px;
	}

	.contact-right p {
		font-size: 16px;
		font-weight: 400;
		color: #FFFFFF;
	}

	.bottom {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 20px;
		font-weight: 500;
		color: #FFFFFF;
		height: 96px;
	}

	.bottom span {
		cursor: pointer;
		transition: all .3s;
	}

	.bottom span:hover {
		color: #FFE81C;
	}

	.download1 {
		position: relative;
		z-index: 999;
	}
	
	.menu p:hover {
		opacity: 1 !important;
	}

	.download1:hover img {
		opacity: 1 !important;
		transition: all .3s;
	}

	.download1 img {
		position: absolute;
		width: 200px;
		height: 200px;
		bottom: -250px;
		left: -45px;
		opacity: 0;
		transition: all .3s;
		box-shadow: 0px 0px 20px rgba(145, 145, 145, 0.5);
	}

	.download2 {
		position: relative;
		z-index: 99;
	}

	.download2:hover img {
		opacity: 1;
		transition: all .3s;
	}

	.download2 img {
		position: absolute;
		width: 200px;
		height: 200px;
		top: -30px;
		right: -250px;
		opacity: 0;
		transition: all .3s;
	}

	.swiper-container {
		width: 400px !important;
		margin-left: 0 !important;
		margin-right: 0 !important;
	}

	.swiper-container img {
		width: 400px;
		height: auto;
	}

	.swipermain-main {}

	.swipermain-word {
		width: 60%;
	}

	.swipermain-word p {
		font-size: 36px;
		margin-bottom: 46px;
		line-height: 42px;
		color: #42506A;
	}

	.swiper-left {
		position: relative;
	}

	.yellow-block {
		position: absolute;
		width: 421px;
		height: 426px;
		background: #FFEC43;
		left: 0;
		top: 400px;
	}
</style>
